/* already loved club — save / share / infinite scroll / AJAX cart */
(function () {
  'use strict';

  // ─── localStorage save set ─────────────────────────────────────
  function readSaved() {
    try { return new Set(JSON.parse(localStorage.getItem('lac_saved') || '[]')); }
    catch { return new Set(); }
  }
  function writeSaved(set) {
    localStorage.setItem('lac_saved', JSON.stringify([...set]));
  }

  // Broadcast save changes so all surfaces update in the same tab
  function broadcastSave(id) {
    document.dispatchEvent(new CustomEvent('lac:save-change', { detail: { id: id } }));
  }

  // ─── Generic save button (pin card version) ────────────────────
  function hookSaveButton(btn) {
    if (btn.dataset.lacHooked) return;
    btn.dataset.lacHooked = '1';
    var id = btn.getAttribute('data-save');
    function render() {
      var s = readSaved();
      if (s.has(id)) {
        btn.classList.add('saved');
        btn.textContent = 'Saved';
      } else {
        btn.classList.remove('saved');
        btn.textContent = 'Save';
      }
    }
    render();
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var cur = readSaved();
      if (cur.has(id)) cur.delete(id); else cur.add(id);
      writeSaved(cur);
      broadcastSave(id);
    });
    document.addEventListener('lac:save-change', function (e) {
      if (e.detail && e.detail.id === id) render();
    });
  }

  function hookAllSaveButtons(root) {
    // Includes: pin card Save button, PDP cherry Save button.
    // Heart icon is handled separately in hookHeartButtons.
    (root || document).querySelectorAll('.lac-save-btn[data-save], .lac-detail-save-btn[data-save]').forEach(hookSaveButton);
  }

  // ─── Heart icon button on product page ─────────────────────────
  function hookHeartButtons() {
    document.querySelectorAll('[data-heart="1"]').forEach(function (btn) {
      if (btn.dataset.lacHeartHooked) return;
      btn.dataset.lacHeartHooked = '1';
      var id = btn.getAttribute('data-save');
      if (!id) return;
      var countEl = document.querySelector('[data-save-count="' + id + '"]');
      var baseCount = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;
      function render() {
        var cur = readSaved();
        if (cur.has(id)) {
          btn.classList.add('saved');
          if (countEl) countEl.textContent = baseCount + 1;
        } else {
          btn.classList.remove('saved');
          if (countEl) countEl.textContent = baseCount;
        }
      }
      render();
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var cur = readSaved();
        if (cur.has(id)) cur.delete(id); else cur.add(id);
        writeSaved(cur);
        broadcastSave(id);
      });
      document.addEventListener('lac:save-change', function (e) {
        if (e.detail && e.detail.id === id) render();
      });
    });
  }

  // ─── Share button ──────────────────────────────────────────────
  function hookShareButtons() {
    document.querySelectorAll('[data-share]').forEach(function (btn) {
      if (btn.dataset.lacShareHooked) return;
      btn.dataset.lacShareHooked = '1';
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();
        var raw = btn.getAttribute('data-share') || '';
        var parts = raw.split('|');
        var url = parts[0] || location.href;
        // If URL is a path (e.g. /products/foo), make it absolute
        if (url.indexOf('http') !== 0) {
          url = location.origin + url;
        }
        var title = parts[1] || document.title;
        if (navigator.share) {
          try {
            await navigator.share({ title: title, url: url });
            return;
          } catch (_) { /* user cancelled */ }
        }
        try {
          await navigator.clipboard.writeText(url);
          showToast('Link copied to clipboard');
        } catch (_) {
          // fallback: textarea hack
          var ta = document.createElement('textarea');
          ta.value = url;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); showToast('Link copied'); }
          catch (err) { showToast('Could not copy'); }
          document.body.removeChild(ta);
        }
      });
    });
  }

  // ─── Toast ─────────────────────────────────────────────────────
  function ensureToast() {
    var t = document.getElementById('lac-toast');
    if (t) return t;
    t = document.createElement('div');
    t.className = 'lac-toast';
    t.id = 'lac-toast';
    t.innerHTML = '<span id="lac-toast-msg"></span>';
    document.body.appendChild(t);
    return t;
  }
  function showToast(msg) {
    var t = ensureToast();
    var msgEl = document.getElementById('lac-toast-msg');
    if (msgEl) msgEl.textContent = msg;
    t.classList.add('show');
    clearTimeout(showToast._to);
    showToast._to = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  // ─── Infinite scroll (clone + re-append) ──────────────────────
  function initInfiniteScroll() {
    var masonry = document.getElementById('lac-masonry');
    var sentinel = document.getElementById('lac-sentinel');
    var endMsg = document.getElementById('lac-end-msg');
    if (!masonry || !sentinel) return;
    if (masonry.dataset.savedGrid === '1') return; // skip on saved page

    var initialPins = Array.from(masonry.querySelectorAll('.lac-pin'));
    if (initialPins.length === 0) return;

    var MAX_BATCHES = 3;
    var batchesLoaded = 0;
    var loading = false;

    // Fisher-Yates shuffle (non-destructive)
    function shuffled(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }

    function appendBatch() {
      if (loading) return;
      if (batchesLoaded >= MAX_BATCHES) {
        sentinel.style.display = 'none';
        if (endMsg) endMsg.style.display = 'block';
        return;
      }
      loading = true;
      requestAnimationFrame(function () {
        var frag = document.createDocumentFragment();
        // Shuffle each batch so clones don't mirror the initial order
        shuffled(initialPins).forEach(function (node, i) {
          var clone = node.cloneNode(true);
          clone.querySelectorAll('[data-lac-hooked]').forEach(function (el) { el.removeAttribute('data-lac-hooked'); });
          clone.querySelectorAll('[data-lac-share-hooked]').forEach(function (el) { el.removeAttribute('data-lac-share-hooked'); });
          // Rotate ratio slightly per batch for more variety
          var pid = parseInt(clone.getAttribute('data-pid'), 10) || 0;
          var newRatio = (pid + batchesLoaded * 3 + i) % 10;
          clone.setAttribute('data-ratio', newRatio);
          frag.appendChild(clone);
        });
        masonry.appendChild(frag);
        hookAllSaveButtons(masonry);
        hookShareButtons();
        if (currentFilter.key !== 'all') applyFilter();
        batchesLoaded++;
        setTimeout(function () { loading = false; }, 200);
      });
    }

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < MAX_BATCHES; i++) appendBatch();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) appendBatch();
      });
    }, { rootMargin: '400px 0px' });
    io.observe(sentinel);
  }

  // ─── Saved page filtering ─────────────────────────────────────
  function renderSavedPage() {
    var grid = document.querySelector('[data-saved-grid="1"]');
    if (!grid) return;
    var saved = readSaved();
    var pins = grid.querySelectorAll('[data-saved-hide="1"]');
    var shown = 0;
    pins.forEach(function (pin) {
      var id = pin.getAttribute('data-pid');
      if (saved.has(id)) {
        pin.style.display = '';
        shown++;
      } else {
        pin.style.display = 'none';
      }
    });
    var empty = document.getElementById('lac-saved-empty');
    if (empty) empty.style.display = shown === 0 ? 'block' : 'none';
    var header = document.getElementById('lac-saved-header');
    if (header) header.textContent = shown + ' saved piece' + (shown === 1 ? '' : 's');
  }

  // ─── Size chips + variant ID (product page) ───────────────────
  function hookSizeChips() {
    var form = document.getElementById('lac-pdp-form');
    if (!form) return;
    var variantInput = document.getElementById('lac-variant-id');
    var variants = window.LAC_PRODUCT_VARIANTS || [];
    form.querySelectorAll('.lac-size-chips').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.lac-size-chip');
        if (!btn) return;
        group.querySelectorAll('.lac-size-chip').forEach(function (c) { c.classList.remove('selected'); });
        btn.classList.add('selected');
        updateVariant();
      });
    });
    function updateVariant() {
      var selected = [];
      form.querySelectorAll('.lac-size-chips').forEach(function (g) {
        var sel = g.querySelector('.lac-size-chip.selected');
        if (sel) selected.push(sel.getAttribute('data-value'));
      });
      var match = variants.find(function (v) {
        return v.options.length === selected.length &&
               v.options.every(function (o, i) { return o === selected[i]; });
      });
      if (match && variantInput) variantInput.value = match.id;
      // ─── Reflect selected variant's availability on the buy button ───
      var btn = form.querySelector('.lac-buy-btn');
      if (!btn) return;
      if (!btn.dataset.lacOriginal) btn.dataset.lacOriginal = btn.innerHTML;
      if (match && match.available === false) {
        btn.disabled = true;
        btn.classList.add('is-soldout');
        btn.innerHTML = '<span>Sold out</span>';
      } else if (match && match.available !== false) {
        btn.disabled = false;
        btn.classList.remove('is-soldout');
        btn.innerHTML = btn.dataset.lacOriginal;
      }
    }
  }

  // ─── Add to cart (product page) ───────────────────────────────
  function hookBuyButton() {
    var form = document.getElementById('lac-pdp-form');
    if (!form) return;
    var btn = form.querySelector('.lac-buy-btn');
    if (!btn) return;
    form.addEventListener('submit', function (e) {
      if (btn.disabled) return;
      e.preventDefault();
      var fd = new FormData(form);
      btn.disabled = true;
      var originalHtml = btn.innerHTML;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || 'Could not add to bag');
        btn.classList.add('added');
        btn.innerHTML = '<span>\u2713 Added</span>';
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          return { added: res.data, cart: cart };
        });
      })
      .then(function (ctx) {
        if (!ctx) return;
        updateCartBadge(ctx.cart.item_count);
        openAddSheet(ctx.added, ctx.cart);
      })
      .catch(function (err) {
        console.error('Add to bag failed:', err);
        btn.innerHTML = '<span>Could not add</span>';
        showToast(err.message || 'Could not add to bag');
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('added');
          btn.innerHTML = originalHtml;
        }, 1800);
      });
    });
    // Re-arm the button when the sheet closes, so customer can add again
    document.addEventListener('lac:sheet-close', function () {
      btn.disabled = false;
      btn.classList.remove('added');
      // Preserve original if still present, otherwise rebuild
      var fresh = form.querySelector('.lac-buy-btn');
      if (fresh && fresh.dataset.lacOriginal) {
        fresh.innerHTML = fresh.dataset.lacOriginal;
      }
    });
    // Remember original button markup once
    if (!btn.dataset.lacOriginal) btn.dataset.lacOriginal = btn.innerHTML;
  }

  // ─── Bottom sheet after add to cart ───────────────────────────
  function openAddSheet(added, cart) {
    var sheet = document.getElementById('lac-add-sheet');
    if (!sheet) return;
    var img = document.getElementById('lac-add-sheet-img');
    var title = document.getElementById('lac-add-sheet-title');
    var variant = document.getElementById('lac-add-sheet-variant');
    var price = document.getElementById('lac-add-sheet-price');
    var total = document.getElementById('lac-add-sheet-total');
    var count = document.getElementById('lac-add-sheet-count');

    if (img && added.image) {
      img.src = added.image;
      img.alt = added.product_title || added.title || '';
    }
    if (title) title.textContent = added.product_title || added.title || '';
    if (variant) {
      var vt = (added.variant_title && added.variant_title !== 'Default Title') ? added.variant_title : '';
      variant.textContent = vt;
    }
    if (price) price.textContent = formatMoney(added.final_line_price || added.price);
    if (total && cart) total.textContent = '· ' + formatMoney(cart.total_price);
    if (count && cart) count.textContent = cart.item_count;

    sheet.classList.add('open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lac-sheet-open');
  }

  function closeAddSheet() {
    var sheet = document.getElementById('lac-add-sheet');
    if (!sheet) return;
    sheet.classList.remove('open');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lac-sheet-open');
    document.dispatchEvent(new CustomEvent('lac:sheet-close'));
  }

  function hookAddSheet() {
    var sheet = document.getElementById('lac-add-sheet');
    if (!sheet) return;
    var closeBtn = document.getElementById('lac-add-sheet-close');
    var continueBtn = document.getElementById('lac-add-sheet-continue');
    if (closeBtn) closeBtn.addEventListener('click', closeAddSheet);
    if (continueBtn) continueBtn.addEventListener('click', closeAddSheet);
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet) closeAddSheet();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('open')) closeAddSheet();
    });
  }

  function updateCartBadge(count) {
    var cartLink = document.querySelector('.lac-nav-icon[href="/cart"]');
    if (!cartLink) return;
    var badge = cartLink.querySelector('.lac-badge');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'lac-badge';
        cartLink.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  // ─── Cart page: qty + remove ─────────────────────────────────
  function hookCartPage() {
    var form = document.getElementById('lac-cart-form');
    if (!form) return;

    form.querySelectorAll('.lac-cart-line').forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var input = line.querySelector('.lac-qty-input');
      var dec = line.querySelector('[data-qty-action="dec"]');
      var inc = line.querySelector('[data-qty-action="inc"]');
      var remove = line.querySelector('.lac-cart-remove');

      function change(newQty) {
        newQty = Math.max(0, parseInt(newQty, 10) || 0);
        line.style.opacity = '0.5';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartBadge(cart.item_count);
          if (newQty === 0) {
            line.remove();
          } else {
            input.value = newQty;
            // Update line total
            var lineItem = cart.items.find(function (i) { return i.key === key; });
            if (lineItem) {
              var priceEl = line.querySelector('.lac-cart-line-price');
              if (priceEl) priceEl.textContent = formatMoney(lineItem.final_line_price);
            }
          }
          // Update summary
          var countEl = document.getElementById('lac-summary-count');
          var totalEl = document.getElementById('lac-summary-total');
          if (countEl) countEl.textContent = cart.item_count;
          if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
          line.style.opacity = '1';
          if (cart.item_count === 0) location.reload();
        })
        .catch(function () { line.style.opacity = '1'; });
      }

      if (dec) dec.addEventListener('click', function () { change(parseInt(input.value, 10) - 1); });
      if (inc) inc.addEventListener('click', function () { change(parseInt(input.value, 10) + 1); });
      if (input) input.addEventListener('change', function () { change(input.value); });
      if (remove) remove.addEventListener('click', function () { change(0); });
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  // ─── Init ─────────────────────────────────────────────────────
  // ─── Category / brand filter chips ─────────────────────────
  var currentFilter = { key: 'all', value: '' };
  function applyFilter(root) {
    var scope = root || document.getElementById('lac-masonry');
    if (!scope) return;
    var pins = scope.querySelectorAll('.lac-pin');
    var shown = 0;
    pins.forEach(function (pin) {
      var show = true;
      if (currentFilter.key === 'type') {
        show = (pin.getAttribute('data-type') || '') === currentFilter.value;
      } else if (currentFilter.key === 'vendor') {
        show = (pin.getAttribute('data-vendor') || '') === currentFilter.value;
      } else if (currentFilter.key === 'size') {
        var sizes = (pin.getAttribute('data-sizes') || '').toLowerCase();
        show = sizes.split(',').indexOf(currentFilter.value.toLowerCase()) !== -1;
      }
      pin.style.display = show ? '' : 'none';
      if (show) shown++;
    });
    // toggle empty state
    var empty = document.getElementById('lac-no-filter-results');
    var sentinel = document.getElementById('lac-sentinel');
    var endMsg = document.getElementById('lac-end-msg');
    if (empty) empty.style.display = (shown === 0) ? 'block' : 'none';
    // Hide infinite scroll sentinel when filter active (showing subset)
    if (sentinel) sentinel.style.display = (currentFilter.key === 'all') ? '' : 'none';
    if (endMsg && currentFilter.key !== 'all') endMsg.style.display = 'none';
  }

  function hookFilterChips() {
    var chipsWrap = document.getElementById('lac-filter-chips');
    var filterBtn = document.getElementById('lac-filter-btn');
    var clearBtn = document.getElementById('lac-clear-filter');
    if (!chipsWrap) return;

    function setActive(chip) {
      chipsWrap.querySelectorAll('.lac-filter-chip').forEach(function (c) {
        c.classList.toggle('active', c === chip);
      });
    }
    function resetToAll() {
      currentFilter = { key: 'all', value: '' };
      var allChip = chipsWrap.querySelector('[data-filter="all"]');
      if (allChip) setActive(allChip);
      applyFilter();
    }

    chipsWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('.lac-filter-chip');
      if (!chip) return;
      var key = chip.getAttribute('data-filter');
      var value = chip.getAttribute('data-value') || '';
      currentFilter = { key: key, value: value };
      setActive(chip);
      applyFilter();
    });

    if (filterBtn) {
      // Toggle show/hide of chips row on narrow screens (future: open modal)
      filterBtn.addEventListener('click', function () {
        filterBtn.classList.toggle('active');
      });
    }
    if (clearBtn) clearBtn.addEventListener('click', resetToAll);
  }

  // ─── Live "X people looking" urgency pill ──────────────────
  function hookUrgency() {
    var pill = document.querySelector('.lac-urgency');
    if (!pill) return;
    var countEl = document.getElementById('lac-watching-count');
    var ageEl = document.getElementById('lac-listed-age');

    // Seed count deterministically from URL so it's consistent per product
    var seed = 0;
    var str = location.pathname;
    for (var i = 0; i < str.length; i++) seed = (seed * 31 + str.charCodeAt(i)) | 0;
    seed = Math.abs(seed);
    var baseCount = 3 + (seed % 16); // 3–18 people
    if (countEl) countEl.textContent = baseCount;

    // Drift the count randomly every 6–14s to feel live
    function drift() {
      if (!countEl) return;
      var cur = parseInt(countEl.textContent, 10) || baseCount;
      var delta = Math.random() < 0.5 ? -1 : 1;
      // keep within reasonable bounds
      if (cur <= 3) delta = 1;
      if (cur >= 22) delta = -1;
      cur += delta;
      // small chance of +2 bump for extra "activity"
      if (Math.random() < 0.15) cur += (Math.random() < 0.5 ? -1 : 1);
      if (cur < 2) cur = 2;
      if (cur > 24) cur = 24;
      countEl.textContent = cur;
      // subtle flash
      countEl.style.transition = 'color 0.3s';
      countEl.style.color = 'var(--lac-red)';
      setTimeout(function () { countEl.style.color = ''; }, 600);
      setTimeout(drift, 6000 + Math.random() * 8000);
    }
    setTimeout(drift, 4000 + Math.random() * 4000);

    // Format "listed Xh ago"
    if (ageEl) {
      var ts = parseInt(pill.getAttribute('data-listed-at'), 10);
      if (ts) {
        var diffSec = Math.max(60, Math.floor(Date.now() / 1000) - ts);
        var label;
        if (diffSec < 3600) label = Math.max(1, Math.floor(diffSec / 60)) + 'm ago';
        else if (diffSec < 86400) label = Math.floor(diffSec / 3600) + 'h ago';
        else if (diffSec < 604800) label = Math.floor(diffSec / 86400) + 'd ago';
        else label = Math.floor(diffSec / 604800) + 'w ago';
        ageEl.textContent = label;
      }
    }
  }

  // ─── "More" dropdown ────────────────────────────────────────
  function hookMoreDropdown() {
    var btn = document.getElementById('lac-more-btn');
    var menu = document.getElementById('lac-more-menu');
    if (!btn || !menu) return;
    function close() {
      menu.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
    }
    function open() {
      menu.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu.classList.contains('open')) close(); else open();
    });
    document.addEventListener('click', function (e) {
      if (!menu.contains(e.target) && !btn.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  // ─── Drop list modal ────────────────────────────────────────
  function hookDropModal() {
    var modal = document.getElementById('lac-drop-modal');
    if (!modal) return;
    var close = document.getElementById('lac-modal-close');
    var form = document.getElementById('lac-drop-form');
    var submitBtn = form ? form.querySelector('.lac-modal-submit') : null;

    function openModal() {
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lac-modal-open');
    }

    // Hook floating Drop List CTA → opens this modal anywhere
    document.querySelectorAll('.lac-drop-cta').forEach(function (btn) {
      if (btn.dataset.lacDropCtaHooked) return;
      btn.dataset.lacDropCtaHooked = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });
    function closeModal() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lac-modal-open');
      // Remember dismissal for 7 days
      try {
        localStorage.setItem('lac_drop_modal_dismissed', Date.now().toString());
      } catch (e) {}
    }

    // Dismiss handlers
    if (close) close.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
    });

    // Tab switching — disables inactive panel inputs so only the active tab submits,
    // and toggles `required` so hidden fields don't block form validation.
    function switchTab(target) {
      modal.querySelectorAll('.lac-tab').forEach(function (t) {
        var isActive = t.getAttribute('data-tab') === target;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      modal.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
        var isActive = panel.getAttribute('data-tab-panel') === target;
        panel.style.display = isActive ? '' : 'none';
        panel.querySelectorAll('input').forEach(function (inp) {
          inp.disabled = !isActive;
          if (!isActive) inp.removeAttribute('required');
        });
      });
      // On SMS tab, require phone. On Email tab, require email.
      if (target === 'email') {
        var emailInp = modal.querySelector('.lac-panel-email');
        if (emailInp) emailInp.setAttribute('required', '');
      } else if (target === 'sms') {
        var phoneInp = modal.querySelector('.lac-panel-phone');
        if (phoneInp) phoneInp.setAttribute('required', '');
      }
    }
    modal.querySelectorAll('.lac-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchTab(tab.getAttribute('data-tab'));
      });
    });
    // Initialize to default active tab
    switchTab('email');

    // Form success — mark as signed up and show success state
    if (form && submitBtn) {
      form.addEventListener('submit', function () {
        try { localStorage.setItem('lac_drop_signup', '1'); } catch (e) {}
        // Let Shopify handle the actual POST; it redirects with ?customer_posted=true
      });
    }

    // If we're returning from Shopify with success flag, show thank-you state
    if (location.search.indexOf('customer_posted=true') !== -1) {
      try { localStorage.setItem('lac_drop_signup', '1'); } catch (e) {}
      openModal();
      if (submitBtn) {
        submitBtn.textContent = '\u2713 You\u2019re on the list';
        submitBtn.classList.add('success');
        submitBtn.disabled = true;
      }
      // Auto-close after 3s
      setTimeout(closeModal, 3000);
      return;
    }

    // Don't show if already signed up or recently dismissed
    var signedUp, dismissedAt;
    try {
      signedUp = localStorage.getItem('lac_drop_signup');
      dismissedAt = parseInt(localStorage.getItem('lac_drop_modal_dismissed') || '0', 10);
    } catch (e) {
      signedUp = null;
      dismissedAt = 0;
    }
    if (signedUp) return;
    var SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;
    if (dismissedAt && (Date.now() - dismissedAt) < SEVEN_DAYS) return;

    // Show after 4 seconds
    setTimeout(openModal, 4000);
  }

  // ─── Similar looks carousel arrows ─────────────────────────
  function hookSimilarCarousel() {
    var scroller = document.getElementById('lac-similar-scroll');
    if (!scroller) return;
    var prev = document.querySelector('[data-similar-prev]');
    var next = document.querySelector('[data-similar-next]');

    function step() {
      var item = scroller.querySelector('.lac-similar-item');
      if (!item) return scroller.clientWidth * 0.8;
      var style = getComputedStyle(scroller);
      var gap = parseFloat(style.gap) || 12;
      return item.getBoundingClientRect().width + gap;
    }
    function update() {
      var atStart = scroller.scrollLeft <= 4;
      var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }
    if (prev) prev.addEventListener('click', function () {
      scroller.scrollBy({ left: -step() * 2, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      scroller.scrollBy({ left: step() * 2, behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', update, { passive: true });
    update();
  }



  // ─── Product Gallery ────────────────────────────────────────
  function hookGallery() {
    var gallery = document.querySelector('.lac-gallery');
    if (!gallery) return;
    var track = document.getElementById('lac-gallery-track');
    if (!track) return;
    var slides = Array.from(track.querySelectorAll('.lac-gallery-slide'));
    if (slides.length <= 1) return;

    var dots = Array.from(gallery.querySelectorAll('.lac-gallery-dot'));
    var thumbs = Array.from(gallery.querySelectorAll('.lac-gallery-thumb'));
    var prev = gallery.querySelector('.lac-gallery-prev');
    var next = gallery.querySelector('.lac-gallery-next');
    var currentEl = document.getElementById('lac-gallery-current');
    var currentIndex = 0;
    var programmaticScroll = false;

    function setActive(i) {
      if (i === currentIndex) return;
      currentIndex = i;
      dots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('active', idx === i);
        t.setAttribute('aria-selected', idx === i ? 'true' : 'false');
      });
      if (currentEl) currentEl.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    // Compute current slide from scrollLeft — deterministic, no observer drift
    function indexFromScroll() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
    }

    // Programmatic navigation — scroll to a specific slide
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      programmaticScroll = true;
      var target = slides[i].offsetLeft;
      track.scrollTo({ left: target, behavior: 'smooth' });
      setActive(i);
      // Release the flag once scroll settles (scrollend fires, or fallback timer)
      setTimeout(function () { programmaticScroll = false; }, 500);
    }

    // Debounced scroll handler — updates indicators as the user swipes
    var scrollRAF = null;
    track.addEventListener('scroll', function () {
      if (scrollRAF) return;
      scrollRAF = requestAnimationFrame(function () {
        scrollRAF = null;
        setActive(indexFromScroll());
      });
    }, { passive: true });

    // Scroll-end hardening: snap to the nearest slide once momentum stops.
    // Fixes iOS "sometimes slides too far" — we re-snap to the exact index.
    var scrollEndTimer = null;
    function settle() {
      if (programmaticScroll) return;
      var i = indexFromScroll();
      var target = slides[i].offsetLeft;
      if (Math.abs(track.scrollLeft - target) > 1) {
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
      setActive(i);
    }

    // Use native scrollend when available, otherwise debounced fallback
    if ('onscrollend' in window) {
      track.addEventListener('scrollend', settle);
    } else {
      track.addEventListener('scroll', function () {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(settle, 140);
      }, { passive: true });
    }

    // Controls
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-index'), 10)); });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-index'), 10)); });
    });
    if (prev) prev.addEventListener('click', function () { go(currentIndex - 1); });
    if (next) next.addEventListener('click', function () { go(currentIndex + 1); });

    // Keyboard nav when not typing
    document.addEventListener('keydown', function (e) {
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if (e.key === 'ArrowLeft') { go(currentIndex - 1); }
      else if (e.key === 'ArrowRight') { go(currentIndex + 1); }
    });

    // Re-snap on resize (orientation change, etc.) so we don't drift mid-slide
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        programmaticScroll = true;
        track.scrollTo({ left: slides[currentIndex].offsetLeft, behavior: 'auto' });
        setTimeout(function () { programmaticScroll = false; }, 100);
      }, 150);
    }, { passive: true });

    // Init
    setActive(0);
    // Ensure we're flush to the first slide on load (Safari sometimes starts off-center)
    requestAnimationFrame(function () { track.scrollLeft = 0; });
  }

  function init() {
    hookAllSaveButtons();
    hookHeartButtons();
    hookShareButtons();
    hookSizeChips();
    hookBuyButton();
    hookAddSheet();
    hookCartPage();
    hookMoreDropdown();
    hookDropModal();
    hookUrgency();
    hookFilterChips();
    hookSimilarCarousel();
    hookGallery();
    initInfiniteScroll();
    renderSavedPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ─── ALC subscribe AJAX (footer + drop popup) ──────────────────
   Routes both forms through our /alc-flows/subscribe endpoint so
   we can set email + SMS marketing consent on the Shopify customer.
   Endpoint: https://app.cynthiaconcierge.com/alc-flows/subscribe
   Forms opt in by adding data-alc-subscribe="<source>" to the <form>.

   Phone fields with class .lac-iti-phone get an intl-tel-input
   country picker (flag + dial code dropdown). On submit, we replace
   the raw national value with the full E.164 (+CC) number so the
   backend gets a valid international format.
*/
(function () {
  var ENDPOINT = 'https://app.cynthiaconcierge.com/alc-flows/subscribe';
  var ITI_VERSION = '25';
  var ITI_CSS = 'https://cdn.jsdelivr.net/npm/intl-tel-input@' + ITI_VERSION + '/build/css/intlTelInput.css';
  var ITI_JS = 'https://cdn.jsdelivr.net/npm/intl-tel-input@' + ITI_VERSION + '/build/js/intlTelInput.min.js';
  var ITI_UTILS = 'https://cdn.jsdelivr.net/npm/intl-tel-input@' + ITI_VERSION + '/build/js/utils.js';

  var itiInstances = new WeakMap();
  var itiLoadPromise = null;

  function loadCss(href) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === '1') return resolve();
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', reject);
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.addEventListener('load', function () { s.dataset.loaded = '1'; resolve(); });
      s.addEventListener('error', reject);
      document.head.appendChild(s);
    });
  }

  function ensureIti() {
    if (window.intlTelInput) return Promise.resolve();
    if (itiLoadPromise) return itiLoadPromise;
    loadCss(ITI_CSS);
    itiLoadPromise = loadScript(ITI_JS);
    return itiLoadPromise;
  }

  function initPhoneField(input) {
    if (itiInstances.has(input)) return itiInstances.get(input);
    if (!window.intlTelInput) return null;
    var iti = window.intlTelInput(input, {
      initialCountry: 'auto',
      geoIpLookup: function (callback) {
        // Best-effort guess via ipapi.co; falls back to US on failure.
        fetch('https://ipapi.co/json/', { mode: 'cors' })
          .then(function (r) { return r.json(); })
          .then(function (j) { callback((j && j.country_code) || 'us'); })
          .catch(function () { callback('us'); });
      },
      preferredCountries: ['us', 'ca', 'gb', 'au'],
      separateDialCode: true,
      autoPlaceholder: 'aggressive',
      formatAsYouType: true,
      formatOnDisplay: true,
      // v25 requires loadUtils (a Promise-returning fn) instead of utilsScript.
      // Without utils.js loaded, formatAsYouType + isValidNumber + getNumber
      // are no-ops — so this is the magic line that enables (xxx) xxx-xxxx
      // live formatting + country-aware validation.
      loadUtils: function () { return import(ITI_UTILS); },
    });
    itiInstances.set(input, iti);
    return iti;
  }

  function setMsg(form, kind, text) {
    var slot = form.querySelector('[data-alc-msg]');
    if (!slot) return;
    slot.classList.remove('ok', 'err');
    if (kind) slot.classList.add(kind);
    slot.textContent = text || '';
  }

  function serialize(form) {
    var out = {};
    var fd = new FormData(form);
    fd.forEach(function (value, key) {
      out[key] = value;
    });
    // Checkbox unchecked -> not in FormData; default to false explicitly.
    if (form.querySelector('input[name="sms_consent"][type="checkbox"]') && !('sms_consent' in out)) {
      out.sms_consent = 'false';
    }
    // Replace raw national phone with full E.164 from intl-tel-input
    var phoneInput = form.querySelector('input.lac-iti-phone');
    if (phoneInput) {
      var iti = itiInstances.get(phoneInput);
      if (iti && typeof iti.getNumber === 'function') {
        var e164 = iti.getNumber();
        if (e164) out.phone = e164;
      }
    }
    return out;
  }

  function isPhoneValid(form) {
    var phoneInput = form.querySelector('input.lac-iti-phone');
    if (!phoneInput) return true;
    var iti = itiInstances.get(phoneInput);
    if (!iti || typeof iti.isValidNumber !== 'function') return phoneInput.value.length >= 7;
    return iti.isValidNumber();
  }

  function bind(form) {
    if (form.dataset.alcSubscribeBound === '1') return;
    form.dataset.alcSubscribeBound = '1';
    var submitBtn = form.querySelector('button[type="submit"], .lac-footer-submit, .lac-modal-submit');
    var origLabel = submitBtn ? submitBtn.textContent : '';
    // Initialize intl-tel-input on any .lac-iti-phone fields in this form.
    var phoneInputs = form.querySelectorAll('input.lac-iti-phone');
    if (phoneInputs.length) {
      ensureIti().then(function () {
        phoneInputs.forEach(initPhoneField);
      }).catch(function () {});
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setMsg(form, '', '');
      if (!isPhoneValid(form)) {
        setMsg(form, 'err', 'please enter a valid phone number for the selected country');
        return;
      }
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'sending…';
      }

      var payload = serialize(form);
      fetch(ENDPOINT, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
        .then(function (resp) {
          if (resp.status >= 200 && resp.status < 300 && resp.body && resp.body.ok) {
            setMsg(form, 'ok', "you're on the list — see you at the next drop ✨");
            if (submitBtn) {
              submitBtn.textContent = '✓ added';
              submitBtn.classList.add('success');
            }
            try { localStorage.setItem('lac_drop_signup', '1'); } catch (e) {}
            // Auto-close popup after success
            var modal = form.closest('.lac-modal-backdrop');
            if (modal) {
              setTimeout(function () {
                modal.classList.remove('open');
                modal.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('lac-modal-open');
              }, 2200);
            }
          } else {
            var msg = (resp.body && (resp.body.error || resp.body.message)) || 'try again in a moment';
            setMsg(form, 'err', msg);
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = origLabel;
            }
          }
        })
        .catch(function (err) {
          setMsg(form, 'err', 'network error — try again');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = origLabel;
          }
        });
    });
  }

  function init() {
    document.querySelectorAll('form[data-alc-subscribe]').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
